export const COMPANY_SEARCH_REQUESTED = 'COMPANY_SEARCH_REQUESTED';
export const COMPANY_SEARCH_RECEIVED = 'COMPANY_SEARCH_RECEIVED';
export const COMPANY_SEARCH_ERROR = 'COMPANY_SEARCH_ERROR';



// WEBPACK FOOTER //
// ./AutoComplete/context/actionTypes.js